export const IncomeSupportAndEmployment = {
  "label": "Income Support And Employment",
  "value": [
    {
      "code": "BH-3000.3500-700",
      "keyword": "Ramp Construction Services"
    },
    {
      "code": "BH-3000.3550",
      "keyword": "Home Rehabilitation Programs"
    },
    {
      "code": "BH-3000.4600",
      "keyword": "Low Cost Building Materials\/Supplies"
    },
    {
      "code": "BH-3500.3400",
      "keyword": "Home Purchase\/Mortgage Refinance Loans"
    },
    {
      "code": "BH-3500.3500",
      "keyword": "Housing Down Payment Loans\/Grants"
    },
    {
      "code": "BH-3700",
      "keyword": "Housing Counseling"
    },
    {
      "code": "BH-3800.1900",
      "keyword": "Emergency Related Eviction\/Foreclosure Moratoriums"
    },
    {
      "code": "BH-3800.1920",
      "keyword": "Emergency Rental Assistance Program (ERAP)"
    },
    {
      "code": "BH-3800.5000",
      "keyword": "Mortgage Payment Assistance"
    },
    {
      "code": "BH-3800.5100",
      "keyword": "Motel Bill Payment Assistance"
    },
    {
      "code": "BH-3800.7000",
      "keyword": "Rent Payment Assistance"
    },
    {
      "code": "BH-3800.7250",
      "keyword": "Rental Deposit Assistance"
    },
    {
      "code": "BH-5000",
      "keyword": "Moving Services"
    },
    {
      "code": "BH-7000.4600-060",
      "keyword": "Barrier Free Rental Housing"
    },
    {
      "code": "BH-7000.4600-280",
      "keyword": "Emergency Housing Voucher (EHV) Program"
    },
    {
      "code": "BH-7000.4600-300",
      "keyword": "Homeless Alternative Housing Developments"
    },
    {
      "code": "BH-7000.4600-450",
      "keyword": "Low Income\/Subsidized Private Rental Housing"
    },
    {
      "code": "BH-7000.4600-700",
      "keyword": "Section 8 Housing Choice Vouchers"
    },
    {
      "code": "BH-7000.5100-330",
      "keyword": "Independent Living Communities\/Complexes"
    },
    {
      "code": "BH-7000.8100-800",
      "keyword": "Sweat Equity Programs"
    },
    {
      "code": "BH-8300.3000",
      "keyword": "Housing Authorities"
    },
    {
      "code": "BT-4500.6500-255",
      "keyword": "Employment Related Transportation"
    },
    {
      "code": "BT-4500.6500-170",
      "keyword": "Disability Related Transportation"
    },
    {
      "code": "NS-9000",
      "keyword": "Unemployment Insurance"
    },
    {
      "code": "HL-8120.7980",
      "keyword": "Student Disability Services"
    },
    {
      "code": "LH-2700.1700",
      "keyword": "Disease\/Disability Information"
    },
    {
      "code": "NL-3000.1500",
      "keyword": "Child Care Expense Assistance"
    },
    {
      "code": "NL-5000.5000",
      "keyword": "Medicaid"
    },
    {
      "code": "NL-5000.5000-800",
      "keyword": "State Medicaid Waiver Programs"
    },
    {
      "code": "NL-5000.8000",
      "keyword": "State\/Local Health Insurance Programs"
    },
    {
      "code": "NL-6000.2000",
      "keyword": "Food Stamps\/SNAP"
    },
    {
      "code": "NL-6000.9500",
      "keyword": "WIC"
    },
    {
      "code": "NS-1800.8000",
      "keyword": "Social Security Disability Insurance"
    },
    {
      "code": "NS-1800.9500",
      "keyword": "Workers Compensation"
    },
    {
      "code": "NS-7000.8000",
      "keyword": "Social Security Retirement Benefits"
    },
    {
      "code": "NS-8000.5000",
      "keyword": "Medicare"
    },
    {
      "code": "NS-8200.8000",
      "keyword": "Social Security Survivors Insurance"
    },
    {
      "code": "NS-9000",
      "keyword": "Unemployment Insurance"
    },
    {
      "code": "NT",
      "keyword": "Temporary Financial Assistance"
    },
    {
      "code": "DF-7000.8250",
      "keyword": "Social Security Numbers"
    },
    {
      "code": "ND-2000",
      "keyword": "Employment Preparation"
    },
    {
      "code": "ND-2000.1500-160",
      "keyword": "Career Counseling"
    },
    {
      "code": "ND-2000.3500-820",
      "keyword": "Training Businesses"
    },
    {
      "code": "ND-2050",
      "keyword": "Employment Transition Counseling"
    },
    {
      "code": "ND-2050.4000",
      "keyword": "Layoff\/Job Loss Counseling"
    },
    {
      "code": "ND-2050.7000",
      "keyword": "Retirement Counseling"
    },
    {
      "code": "ND-2050.9500",
      "keyword": "Workforce Reentry Programs"
    },
    {
      "code": "ND-3500.3500-360",
      "keyword": "Job Fairs"
    },
    {
      "code": "ND-3500.3600",
      "keyword": "Job Search\/Placement"
    },
    {
      "code": "ND-3600.2000",
      "keyword": "Full Time Employment"
    },
    {
      "code": "ND-6500.3500",
      "keyword": "Job Corps"
    },
    {
      "code": "ND-6500.8000",
      "keyword": "Senior Community Service Employment Programs"
    },
    {
      "code": "ND-6500.9500",
      "keyword": "Welfare to Work Programs"
    },
    {
      "code": "ND-9000",
      "keyword": "Vocational Rehabilitation"
    },
    {
      "code": "ND-9200.0300",
      "keyword": "AmeriCorps"
    },
  ]
}
